import DOMPurify from 'dompurify';

// Single allowlist for stored newsletter HTML, editor input and excerpts.
// No forms, executable URLs, SVG/MathML, embeds or attacker-controlled CSS.
const POLICY = {
  ALLOWED_TAGS: ['p','br','div','span','strong','b','em','i','u','s','strike','h1','h2','h3','h4','h5','h6','ul','ol','li','blockquote','pre','code','a','img','hr','table','thead','tbody','tr','th','td','font','sub','sup'],
  ALLOWED_ATTR: ['href','src','alt','title','target','rel','width','height','align','colspan','rowspan','color','size','face'],
  ALLOW_DATA_ATTR: false,
  ALLOW_ARIA_ATTR: false,
  SANITIZE_NAMED_PROPS: true,
};

export const safeContentUrl = (value, { image = false } = {}) => {
  const raw = String(value || '').trim();
  if (!raw || /[\u0000-\u0020\u007f]/.test(raw)) return '';
  try {
    const url = new URL(raw, window.location.origin);
    const allowed = image ? ['https:', 'http:'] : ['https:', 'http:', 'mailto:', 'tel:'];
    return allowed.includes(url.protocol) ? raw : '';
  } catch { return ''; }
};

const cleanFragment = value => {
  const fragment = DOMPurify.sanitize(String(value || ''), { ...POLICY, RETURN_DOM_FRAGMENT: true });
  fragment.querySelectorAll('a, img').forEach(node => {
    const attr = node.tagName === 'IMG' ? 'src' : 'href';
    const safe = safeContentUrl(node.getAttribute(attr), { image: attr === 'src' });
    if (safe) node.setAttribute(attr, safe); else node.removeAttribute(attr);
    if (node.tagName === 'A') {
      if (node.getAttribute('target') === '_blank') node.setAttribute('rel', 'noopener noreferrer');
      else node.removeAttribute('target');
    }
  });
  return fragment;
};

export const sanitizeHtml = value => {
  const container = document.createElement('template');
  container.content.append(cleanFragment(value));
  return container.innerHTML; // Read only: all nodes came through the allowlist.
};

export const htmlToText = value => cleanFragment(value).textContent || '';

export const setSafeEditorHtml = (element, value) => {
  // Never insert unsanitized HTML into a live contentEditable DOM.
  element.replaceChildren(cleanFragment(value));
};
